import { ref } from 'vue'
import type { Ref } from 'vue'
import type { Router } from 'vue-router'
import { paymentApi } from '@/api'
import type { useAuthStore } from '@/stores/auth'

type AuthStore = ReturnType<typeof useAuthStore>

type UseChapterUnlockOptions = {
  authStore: AuthStore
  router: Router
  currentChapter: Ref<number>
  findChapterIdByNumber: (chapterNumber: number) => number | null
  loadChapterContent: () => Promise<void>
}

export const useChapterUnlock = (options: UseChapterUnlockOptions) => {
  const isUnlocking = ref(false)

  const unlockChapter = async () => {
    if (!options.authStore.isAuthenticated) {
      options.router.push('/login')
      return
    }

    try {
      isUnlocking.value = true

      const chapterId = options.findChapterIdByNumber(options.currentChapter.value)
      if (!chapterId) {
        throw new Error('章节不存在')
      }

      const unlockResponse = await paymentApi.unlockChapterPack({ chapterId })
      if (unlockResponse.code !== 200 || !unlockResponse.data) {
        throw new Error('解锁失败')
      }

      options.authStore.updateBalance(unlockResponse.data.balance)
      await options.loadChapterContent()

      alert(`解锁成功！第 ${unlockResponse.data.pack.start}-${unlockResponse.data.pack.end} 章已开放。`)
    } catch (err: any) {
      console.error('解锁章节失败:', err)
      if (err.response?.data?.data?.needRecharge) {
        alert(`蜜豆不足，需要 ${err.response.data.data.required} 蜜豆，请先充值。`)
      } else {
        alert(err.message || '解锁失败，请重试')
      }
    } finally {
      isUnlocking.value = false
    }
  }

  return {
    isUnlocking,
    unlockChapter
  }
}
